import styled from 'styled-components';

export default styled.h1.attrs({
  className: 'my-items-title'
})`
  margin: 1rem 0 1rem;
  font-size: 1.75rem;
  font-weight: bold;
  text-align: center;
`;
